import { render, staticRenderFns } from "./global-events.vue?vue&type=template&id=67901814&scoped=true&"
import script from "./global-events.vue?vue&type=script&lang=js&"
export * from "./global-events.vue?vue&type=script&lang=js&"
import style0 from "./global-events.vue?vue&type=style&index=0&id=67901814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67901814",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67901814')) {
      api.createRecord('67901814', component.options)
    } else {
      api.reload('67901814', component.options)
    }
    module.hot.accept("./global-events.vue?vue&type=template&id=67901814&scoped=true&", function () {
      api.rerender('67901814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/global-events.vue"
export default component.exports